/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoAppDetailRequest model module.
 * @module model/CampaignControllerDtoAppDetailRequest
 * @version 1.0
 */
class CampaignControllerDtoAppDetailRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoAppDetailRequest</code>.
     * @alias module:model/CampaignControllerDtoAppDetailRequest
     * @param appNo {Number} 
     */
    constructor(appNo) { 
        
        CampaignControllerDtoAppDetailRequest.initialize(this, appNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, appNo) { 
        obj['appNo'] = appNo;
    }

    /**
     * Constructs a <code>CampaignControllerDtoAppDetailRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoAppDetailRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoAppDetailRequest} The populated <code>CampaignControllerDtoAppDetailRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoAppDetailRequest();

            if (data.hasOwnProperty('appNo')) {
                obj['appNo'] = ApiClient.convertToType(data['appNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoAppDetailRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoAppDetailRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CampaignControllerDtoAppDetailRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

CampaignControllerDtoAppDetailRequest.RequiredProperties = ["appNo"];

/**
 * @member {Number} appNo
 */
CampaignControllerDtoAppDetailRequest.prototype['appNo'] = undefined;






export default CampaignControllerDtoAppDetailRequest;

